import React from 'react';

import ArtWork from './Artworks';

const CSS = require('./PassionArtwork.less');

function PassionArtwork({ name, inView }) {
  if (!inView) {
    return (
      <span className={CSS.Placeholder} aria-hidden="true">
        {name}
      </span>
    );
  }

  const artworkName = name.toLowerCase().split(' ').join('');

  return (
    <div className={CSS.ArtWork}>
      <ArtWork name={artworkName} fill="white" />
    </div>
  );
}

export default PassionArtwork;
